import {
  BETBY_BETSLIP_BOTTOM_GAP_PX,
  BETBY_BOTTOM_NAV_SELECTOR,
  BETBY_DESKTOP_BREAKPOINT_PX,
  BETBY_HEADER_OFFSET_PX,
  BETBY_HEADER_SELECTOR,
  BETBY_MOBILE_FOOTER_OFFSET_PX
} from "@/constants/betby"

export interface BetbyLayoutOffsets {
  stickyTop: number
  betSlipOffsetTop: number
  betSlipOffsetBottom: number
}

function measureBottomNavClearance(
  bottomNav: Element | null,
  isDesktop: boolean
): number {
  if (isDesktop) {
    return 0
  }

  if (!(bottomNav instanceof HTMLElement)) {
    return BETBY_MOBILE_FOOTER_OFFSET_PX
  }

  const clearance = Math.round(
    window.innerHeight - bottomNav.getBoundingClientRect().top
  )

  if (clearance <= 0) {
    return BETBY_MOBILE_FOOTER_OFFSET_PX
  }

  return clearance + BETBY_BETSLIP_BOTTOM_GAP_PX
}

export const measureBetbyLayoutOffsets = (): BetbyLayoutOffsets => {
  const header = document.querySelector(BETBY_HEADER_SELECTOR)
  const bottomNav = document.querySelector(BETBY_BOTTOM_NAV_SELECTOR)
  const isDesktop = window.innerWidth >= BETBY_DESKTOP_BREAKPOINT_PX

  const headerHeight =
    header instanceof HTMLElement
      ? Math.round(header.getBoundingClientRect().height)
      : BETBY_HEADER_OFFSET_PX

  const stickyTop = headerHeight > 0 ? headerHeight : BETBY_HEADER_OFFSET_PX
  const betSlipOffsetBottom = measureBottomNavClearance(bottomNav, isDesktop)

  return {
    stickyTop,
    betSlipOffsetTop: stickyTop,
    betSlipOffsetBottom
  }
}
